<script>
  import { beforeUpdate, onMount } from 'svelte'
  import { pages, getPageContent } from '../../models/pages.js'

  export var params

  let page = null
  let urlPath = null
  let loading = false
  let pageLoaded = { path: null, loaded: false }

  onMount(async () => {
    await pages.loadPages()
  })

  beforeUpdate(async () => {
    if (
      params.id &&
      pageLoaded.path !== params.id &&
      !loading
    ) {
      loading = true
      urlPath = `info/${params.id}`
      page = await getPageContent(urlPath)
      pageLoaded = { path: params.id, loaded: true }
      loading = false
      if (page) {
        document.title = `${page.name} | Missing Piece Puzzle Exchange`
      }
    }
  })

  $: activePages = $pages
    ? $pages.filter((p) => p.active === true && p.type !== 'blog' && p.type !== 'notification')
    : []
</script>

<style type="text/less">
  .container {
    max-width: var(--content-width-sm);
    margin: 2rem auto;
    padding: 0 var(--spacing);
    display: flex;
    gap: var(--spacing-lg);
    align-items: flex-start;
  }

  .info-sidebar {
    min-width: 200px;
    flex-shrink: 0;
    position: sticky;
    top: var(--spacing);

    h4 {
      margin: 0 0 var(--spacing-sm);
      font-size: 0.8rem;
      text-transform: uppercase;
      letter-spacing: 0.07em;
      color: var(--col-gray-50);
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      border-left: 2px solid var(--col-gray-80);
    }

    li a {
      display: block;
      padding: var(--spacing-sm);
      font-size: 0.9rem;
      margin-left: -2px;
      border-left: 2px solid transparent;

      &:link, &:visited {
        text-decoration: none;
        color: var(--col-gray-40);
      }

      &:hover, &:focus {
        color: var(--col-text);
      }
    }

    li.active a {
      &:link, &:visited {
        color: var(--col-text);
      }
      border-left-color: var(--col-accent-2);
    }
  }

  .info-content {
    flex: 1;
    min-width: 0;

    h1 {
      margin-top: 0;
    }
  }

  .loading {
    color: var(--col-gray-50);
  }

  @media (max-width: 700px) {
    .container {
      flex-direction: column;
    }

    .info-sidebar {
      width: 100%;
      min-width: unset;
      position: static;
    }
  }
</style>

<svelte:head>
  {#if page}
    <title>{page.name} | Missing Piece Puzzle Exchange</title>
    <meta name="description" content={page.meta_description || `${page.name} — Missing Piece Puzzle Exchange`} />
    <meta property="og:title" content="{page.name} | Missing Piece Puzzle Exchange" />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.puzzleexchange.com/info/{params.id}" />
    <link rel="canonical" href="https://www.puzzleexchange.com/info/{params.id}" />
  {/if}
</svelte:head>

<div class="container">
  {#if activePages.length > 0}
    <aside class="info-sidebar">
      <h4>Info</h4>
      <ul>
        {#each activePages as p}
          <li class:active={p.url_path === urlPath}>
            <a href={`/${p.url_path}`}>{p.name}</a>
          </li>
        {/each}
      </ul>
    </aside>
  {/if}

  <div class="info-content">
    {#if loading}
      <p class="loading">Loading...</p>
    {:else if page}
      <article>
        <h1>{page.name}</h1>
        {@html page.html_content}
      </article>
    {:else if params.id}
      <p>We couldn't find that page.</p>
    {/if}
  </div>
</div>
